<!-- 课程 -->
<template>
    <el-dialog v-dialogDrag :title="title" :visible.sync="dialogVisible" width="550px" top="200px"
        :modal-append-to-body="false">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="已选择职位：">
                <span class="color_red">{{ postForm.biddings.length }}个</span>
            </el-form-item>
            <el-form-item :class="'box'" label="">
                <span>
                    我的报价
                </span>
                <span class="padding_5">
                    =
                </span>
                <span>
                    每个职位市场报价
                </span>
                <span class="padding_5">
                    +
                </span>
                <span class="color_red">
                    我的增加价格
                </span>
            </el-form-item>
            <el-form-item label="我的增加价格：" prop="quoted_price">
                <el-input placeholder="请输入报价..." v-model="ruleForm.quoted_price"  type="number" min="0" >
                    <template slot="append">
                        <span class="color_red">元</span>
                    </template>
                </el-input>
            </el-form-item>
        </el-form>

        <!-- v-if  从新渲染 -->
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleOk">确 定</el-button>
            <el-button @click="dialogVisible = false">取 消</el-button>

        </span>
    </el-dialog>
</template>

<script>
export default {
    props: {

    },
    data() {
        const  validateInput=(rule, value, callback)=> {
            const reg = /^\d+(\.\d{1,2})?$/
            if (!reg.test(value)) {
                callback(new Error('请输入正确的数字（最多两位小数）'))
            } else {
                callback()
            }
        }
        return {
            dialogVisible: false,
            title: '批量竞价',
            ruleForm: {

            },
            postForm: {
                'enterprise_id': localStorage.getItem('enterprise_id'),
                'enterprise_name': '',
                biddings: []
            },
            options: JSON.parse(localStorage.getItem('entinfolist')),
            rules: {
                quoted_price: [
                    {  validator:validateInput,  trigger: 'blur' },

                ],
                enterprise_id: [
                    { required: true, message: '请选择所属企业', trigger: 'change' }
                ],
            }
        }
    },
    directives: {
        numericInput: {
            bind(el, binding, vnode) {
                el.addEventListener('input', (event) => {
                    let value = event.target.value;

                    if (value.indexOf('.') > -1) {
                        value = value.slice(0, value.indexOf('.') + 3); // 限制小数点后最多两位数
                    }
                    // 确保不是以小数点开头，也不是纯小数点或负数
                    if (value !== '' && !/\./.test(value)) { // 没有小数点时，确保不是负数或非数字字符串

                    } else if (value === '' || value === '.') { // 清除输入或只有一个点时清空值
                        value = '';
                    }
                    event.target.value = value; // 更新值以触发v-model的setter（如果需要的话）
                    vnode.context[binding.expression] = parseFloat(value); // 更新绑定的值（如果需要的话） // 否则更新值

                });
            }
        }
    },
    created() {

    },
    methods: {
       
        init(data) {
            this.ruleForm = {
                quoted_price: '',
            }
            this.postForm = {
                'enterprise_id': localStorage.getItem('enterprise_id'),
                'enterprise_name': '',
                biddings: data.map(item => {
                    return {
                        'recruitment_id': item.recruitment_id,
                        'quoted_price': item.max_bidding_price,
                    }
                })
            }
            let obj = this.recursion(this.options)

            this.postForm.enterprise_name = obj.enterprise_name
        },
        handleClose(done) {

            done();

        },
        handleOk() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.postForm.biddings.forEach(item => {
                        item.quoted_price = Number(item.quoted_price) + Number(this.ruleForm.quoted_price)
                    })



                    this.$tools
                        .asyncPost(
                            this,
                            this.$baseUrl.biddingApplicationBatchAdd, {
                            data: this.postForm
                        }).then((res) => {
                            if (res.data.code == 0) {
                                this.$message({ type: "success", message: '竞价申请成功，请耐心等待竞价结果通知' });
                                this.$emit('ok')
                                this.dialogVisible = false


                            } else {
                                this.$message({ type: "error", message: res.data.msg });
                            }
                        }).catch((err) => {
                            // this.loading = false; 
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        recursion(arr) {
            let obj;
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].options) {
                    obj = this.recursion(arr[i].options)
                    if (obj) {
                        return obj
                    }
                }
                if (arr[i].enterprise_id && arr[i].enterprise_id == this.postForm.enterprise_id) {
                    // obj = arr[i]

                    return arr[i];
                }
            }

        },
        handleChange(value) {
            console.log(value);
            let obj = this.recursion(this.options)

            this.ruleForm.enterprise_name = obj.enterprise_name
        },

        getOptions() {


            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.trainingOutlineTree, {
                    data: this.postForm3
                }).then((res) => {
                    if (res.data.code == 0) {
                        res.data.data.forEach(item => {
                            item.fold = true
                        })
                        this.options = res.data.data


                    } else {
                        this.$message({ type: "error", message: res.data.msg });
                    }
                    this.loading = false;
                }).catch((err) => { this.loading = false; });
        },
    }
}
</script>

<style lang="less" scoped>
/deep/ .box {
    .el-form-item__content {
        margin-left: 0 !important;
    }
}
</style>
